import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

export default ArrowForwardIcon;